import { TAILWIND_COLORS } from "#src/utils/common";
import { Typography } from "@lockerpm/design";
import { ReactNode } from "react";
import { badgeColors, tailwindColorClasses } from "#src/commonV2/badges/utils";
import { twMerge } from "tailwind-merge";

interface ICustomBadgeProps {
  name: string;
  color: (typeof badgeColors)[number];
  icon?: ReactNode;
  overwriteClassName?: string;
}

/** Similar to BadgeV2, but we change font-size and padding to make it look more appealing. */
export const CustomBadgeV2ForStatus = ({
  name,
  color,
  icon,
  overwriteClassName,
}: ICustomBadgeProps) => {
  return (
    <div
      className={twMerge(
        "px-3 py-1 h-fit w-fit flex items-center gap-1 rounded-full font-medium text-xs border",
        tailwindColorClasses[color],
        overwriteClassName
      )}
    >
      {icon}
      <Typography.Text
        ellipsis={{
          tooltip: {
            color: TAILWIND_COLORS["gray-v2-900"],
            title: (
              <p className="text-white text-xs font-semibold text-center">
                {name}
              </p>
            ),
          },
        }}
      >
        {name}
      </Typography.Text>
    </div>
  );
};
